module.exports = __webpack_public_path__ + "static/logo-EA-9ab7086270dea4b2ff9be365aa40b2d8.png";